<template>
    <div class="header">
    <a
      href="/"
    >ＬＥＣ ＣＢＴ試験
</a>

    <hr class="m-0"/>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from "vue-property-decorator";

import StorageService from "../services/storage";

@Component
export default class Header extends Vue {

  created() {

  }
  mounted() {}
}
</script>
<style scoped>
.header {
  height: 70px;
  background-color: #eee;
  text-align: center;
}

.header a {
  line-height: 70px;
  text-decoration: none;
  color: #212529;
  font-size: 1.2em;
  font-weight: bold;
}

</style>